import type { TrackingFn } from '@change-corgi/core-react/tracking';

function getTrackingCommonData() {
	return {
		location: 'instagram_stories',
	};
}

export function trackShare(
	eventName: string,
	trackingData: Record<string, string | number | boolean | undefined> | undefined,
	track: TrackingFn,
): void {
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}

export function trackShareFailure(
	eventName: string,
	trackingData: Record<string, string | number | boolean | undefined> | undefined,
	track: TrackingFn,
): void {
	void track(eventName, { ...getTrackingCommonData(), ...trackingData });
}
